// extracted by mini-css-extract-plugin
var _1 = "ListingProfileWidgetPortalsRowContent-moduledate__BterU";
var _2 = "ListingProfileWidgetPortalsRowContent-modulelines__Yh7dG";
var _3 = "ListingProfileWidgetPortalsRowContent-modulelogo__UETf1 Avatar-moduleavatar__cNFgJ";
var _4 = "ListingProfileWidgetPortalsRowContent-moduletrailing__JinAt";
export { _1 as "date", _2 as "lines", _3 as "logo", _4 as "trailing" }
